import { useTranslation } from "react-i18next";
import RevenueStats from "@/components/admin/finance/RevenueStats";
import RevenueChart from "@/components/admin/finance/RevenueChart";
import TransactionTable from "@/components/admin/finance/TransactionTable";

export default function AdminFinance() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-7xl px-6 md:px-8 py-8">
      <div className="mb-8 space-y-1">
        <h2 className="text-4xl font-black tracking-tighter text-[#1A1A1A]">{t('admin.finance.title')}</h2>
        <p className="text-lg font-medium text-gray-500">{t('admin.finance.subtitle')}</p>
      </div>

      <RevenueStats />
      
      <RevenueChart />

      <TransactionTable />
    </div>
  );
}
